<template>
  <v-layout row wrap>
    <v-flex xs12>
      <SummaryTitle
        :isCollapsible="isCollapsible"
        :isCollapsed="isCollapsed"
        icon="person_outline"
        @clickedToggle="toggleIsCollapsed">
        Inspector
      </SummaryTitle>
    </v-flex>

    <template v-if="!contentIsCollapsed">
      <v-flex xs12>
        <p class="summary--sidebar-title">{{inspectorName}}</p>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

import SummaryTitle from '@/components/common/SummaryTitle.vue';
import CollapsibleSection from '@/mixins/CollapsibleSection';

export default {
  components: {
    SummaryTitle,
  },
  mixins: [CollapsibleSection],
  computed: {
    ...mapState('Appointment', {
      inspectorName: state => state.dateComponentData.fullName,
    }),
  },
};
</script>
